import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell, Field, SubmitBtn, ErrorNote } from "./AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1600);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Nouveau mot de passe"
      subtitle="Choisissez un nouveau mot de passe pour votre compte."
      footer={
        <Link to="/login" className="font-semibold text-[#3E7256] hover:underline">
          Retour à la connexion
        </Link>
      }
    >
      {!token ? (
        <ErrorNote>Lien invalide : aucun jeton fourni.</ErrorNote>
      ) : done ? (
        <div
          data-testid="reset-success"
          className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800"
        >
          Mot de passe mis à jour. Redirection vers la connexion…
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <ErrorNote>{error}</ErrorNote>
          <Field
            label="Nouveau mot de passe"
            type="password"
            data-testid="reset-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="6 caractères minimum"
            required
            minLength={6}
          />
          <SubmitBtn loading={loading} data-testid="reset-submit">
            Réinitialiser
          </SubmitBtn>
        </form>
      )}
    </AuthShell>
  );
}
